// TODO: simplify when module namespaced
export const NEX_EXTRAS_PROCESS_CLEAR_STATE = "clearNewExtrasProcess";

// TODO: simplify when module namespaced
export const NEX_EXTRAS_PROCESS_CLEAR_ACTION = "clearNewExtrasProcessAction";

export const NewExtrasProcessStoreActions = {
	CLEAR: `${NEX_EXTRAS_PROCESS_CLEAR_ACTION}`
} as const;
